import {resolveBackground} from '#core/utils/color-utils.js';

import {registerTileSchema} from '#core/application/schema-registry.js';

import {generateScrollButtonPane} from '#core/application/modules/tiles/control-button/index.js';

import SPORT_FILTER_CIRCLE_BUTTON from './sport-filter-circle-button.palette-schema.yaml';

registerTileSchema(SPORT_FILTER_CIRCLE_BUTTON);

const SPORT_FILTER_CIRCLE_BUTTON_ITEM_SIZE = 36;
const SPORT_FILTER_CIRCLE_BUTTON_ICON_SIZE = 20;
const SPORT_FILTER_CIRCLE_BUTTON_INACTIVE_ICON_FILTER = 'grayscale(1) opacity(0.5)';
const SPORT_FILTER_CIRCLE_BUTTON_ALL_SPORTS_ITEM_ICON_INACTIVE_OPACITY = 0.55;

export function generateSportFilterCircleRowButton(TILE) {
    const ITEM_BASE = {
        flexGrow: 0,
        flexShrink: 0,
        width: SPORT_FILTER_CIRCLE_BUTTON_ITEM_SIZE,
        height: SPORT_FILTER_CIRCLE_BUTTON_ITEM_SIZE,
        minWidth: SPORT_FILTER_CIRCLE_BUTTON_ITEM_SIZE,
        minHeight: SPORT_FILTER_CIRCLE_BUTTON_ITEM_SIZE,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 0,
        overflow: 'hidden',
        borderRadius: SPORT_FILTER_CIRCLE_BUTTON_ITEM_SIZE,
        borderStyle: 'solid',
        borderWidth: TILE.SPORT_FILTER_CIRCLE_BUTTON_ITEM_BORDER_WIDTH,
        transitionProperty: 'background-color, border-color, fill',
        transitionDuration: '0.15s',
        transitionTimingFunction: 'ease-out',
    };

    return {
        unselected: {
            style: {
                base: {
                    ...ITEM_BASE,
                    ...TILE.SPORT_FILTER_CIRCLE_BUTTON_TEXT,
                    ...resolveBackground(TILE.SPORT_FILTER_CIRCLE_BUTTON_ITEM_BG),
                    borderColor: TILE.SPORT_FILTER_CIRCLE_BUTTON_ITEM_BORDER_COLOR,
                },
                hover: {
                    borderColor: TILE.SPORT_FILTER_CIRCLE_BUTTON_ITEM_HOVER_BORDER_COLOR,
                },
            },
        },
        selected: {
            style: {
                base: {
                    ...ITEM_BASE,
                    ...TILE.SPORT_FILTER_CIRCLE_BUTTON_SELECTED_TEXT,
                    ...resolveBackground(TILE.SPORT_FILTER_CIRCLE_BUTTON_ITEM_SELECTED_BG),
                    borderColor: TILE.SPORT_FILTER_CIRCLE_BUTTON_ITEM_SELECTED_BORDER_COLOR,
                },
            },
        },
        indicator: {
            style: {
                base: {
                    height: 0,
                },
            },
        },
    };
}

export function generateSportFilter(TILE) {
    return {
        sportFilterDefaultAccentColor: TILE.SPORT_FILTER_CIRCLE_BUTTON_DEFAULT_ACCENT_COLOR,
        sportFilterAccentColors: TILE.SPORT_FILTER_CIRCLE_BUTTON_ACCENT_COLORS,
        sportFilterAllSportsBackgroundColor: TILE.SPORT_FILTER_CIRCLE_BUTTON_ALL_SPORTS_BACKGROUND_COLOR,
        allSportsItemIcon: {
            style: {
                width: SPORT_FILTER_CIRCLE_BUTTON_ICON_SIZE,
                height: SPORT_FILTER_CIRCLE_BUTTON_ICON_SIZE,
                fill: TILE.SPORT_FILTER_CIRCLE_BUTTON_ALL_SPORTS_ICON_COLOR,
                stroke: TILE.SPORT_FILTER_CIRCLE_BUTTON_ALL_SPORTS_ICON_COLOR,
                opacity: SPORT_FILTER_CIRCLE_BUTTON_ALL_SPORTS_ITEM_ICON_INACTIVE_OPACITY,
            },
        },
        selectedAllSportsItemIcon: {
            style: {
                width: SPORT_FILTER_CIRCLE_BUTTON_ICON_SIZE,
                height: SPORT_FILTER_CIRCLE_BUTTON_ICON_SIZE,
                fill: TILE.SPORT_FILTER_CIRCLE_BUTTON_ALL_SPORTS_SELECTED_ICON_COLOR,
                stroke: TILE.SPORT_FILTER_CIRCLE_BUTTON_ALL_SPORTS_SELECTED_ICON_COLOR,
            },
        },
        sportsMenuRow: generateSportFilterCircleRow(TILE),
    };
}

export function generateSportFilterCircleRow(TILE) {
    const ICON_SIZE = SPORT_FILTER_CIRCLE_BUTTON_ICON_SIZE;

    return {
        style: {
            container: {
                height: 'auto',
                minHeight: SPORT_FILTER_CIRCLE_BUTTON_ITEM_SIZE,
                flexGrow: 1,
                flexShrink: 1,
                minWidth: 0,
                justifyContent: 'flex-start',
            },
        },
        item: generateSportFilterCircleRowButton(TILE),
        itemInnerContainer: {
            itemSpacing: '0',
            style: {
                width: '100%',
                height: '100%',
            },
        },
        itemIcon: {
            style: {
                width: ICON_SIZE,
                height: ICON_SIZE,
                fill: TILE.SPORT_FILTER_CIRCLE_BUTTON_ICON_COLOR,
                filter: SPORT_FILTER_CIRCLE_BUTTON_INACTIVE_ICON_FILTER,
            },
        },
        selectedItemIcon: {
            style: {
                width: ICON_SIZE,
                height: ICON_SIZE,
                fill: TILE.SPORT_FILTER_CIRCLE_BUTTON_SELECTED_ICON_COLOR,
                filter: 'none',
            },
        },
        buttonScrollPane: {
            ...generateScrollButtonPane(TILE.SPORT_FILTER_CIRCLE_BUTTON_SCROLL_BUTTON),
            scrollPaneContainer: {
                style: {
                    padding: 0,
                },
            },
            contentContainer: {
                itemSpacing: 8,
                style: {
                    alignItems: 'center',
                    padding: 0,
                    _mobile_padding: 0,
                },
            },
        },
    };
}
